<template>
  <v-card>
    <v-card-text>
      <v-form
        ref="form"
        class="d-flex flex-column"
        v-model="valid"
        height=100%
      >
        <v-row align="center" justify="center">
          <v-col>
            Monto inicial de créditos:
          </v-col>
          <v-col >
            <v-text-field v-if="!cannotEdit" v-model="activeFundingCampaign.creditsAmount" />
            <p v-else> {{activeFundingCampaign.creditsAmount}} </p>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col>
            Precio por crédito:
          </v-col>
          <v-col>
            <v-text-field v-if="!cannotEdit" v-model="activeFundingCampaign.creditPrice" :prefix="projectCurrency.symbol"/>
            <p v-else> {{activeFundingCampaign.creditPrice}} </p>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" v-if="cannotEdit">
          <v-col>
            Créditos disponibles:
          </v-col>
          <v-col>
            <p> {{activeFundingCampaign.creditsAmount - activeFundingCampaign.creditsFunded}} </p>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" v-if="cannotEdit">
          <progress-display :total-amount="activeFundingCampaign.creditsAmount" :total-consume="activeFundingCampaign.creditsFunded" />
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              v-if="fundingCampaign.status === 3"
              color="success"
              class="mr-5"
              @click.native.once="closeCampaign"
            >
              Cerrar campaña
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          class="justify-center mt-5"
        >
          <v-btn
            v-if="!cannotEdit"
            :disabled="!valid && !isSaving"
            color="success"
            class="mr-5"
            @click.native.once="saveCampaign"
          >
            {{(isEditing)?'Editar':'Crear'}}
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>  
</template>
<script>
export default {
  components:{
    ProgressDisplay:()=>import('@/components/ProgressDisplay.vue')
  },
  props:{
    fundingCampaign:{
      type: Object,
      default:function(){ 
        return { 
          fundingCampaignId: 0,
          projectId: parseInt(this.$route.params.id),
          creditsAmount: 0,
          creditsFunded: 0,
          creditPrice: 0,
          status: 0
        }
      }
    },
    projectCurrency:{
      type:Object,
      default: function(){
        return {
          symbol:"$",
          text: "ARS"
        }
      }
    }
  },
  data(){
    return {
      activeFundingCampaign: {},
      isSaving:false,
      isEditing:false,
      valid:false,
      cannotEdit: false,
      requiredRule: [
        v => v!==0 || 'Este campo es obligatorio.'
      ],     
    }
  },
  mounted(){
    this.activeFundingCampaign =this.fundingCampaign
    if(this.activeFundingCampaign.status >=3){
      this.cannotEdit = true
    } else if(this.fundingCampaign.creditsAmount!==0){
      this.isEditing = true
    }
  },
  methods:{
    saveCampaign(){
      if(this.valid){
        this.isSaving = true
        this.$cf_api.postFundingCampaign({projectId: this.activeFundingCampaign.projectId, creditsAmount: parseInt( this.activeFundingCampaign.creditsAmount), creditPrice: parseFloat(this.activeFundingCampaign.creditPrice)}).then(()=>{
          this.$store.dispatch('setSnack', 'Se ha creado la campaña de fondeo correctamente.')
          this.$emit('newCampaign')          
        }).catch(e=>{
          this.$store.dispatch('setSnack', 'Ha habido un error. Intentar nuevamente mas tarde.')
          console.log('Error saving campaign. Error: ', e)
        }).finally(()=>{
          this.isSaving = false
        })
      }
    },
    closeCampaign(){
      this.isSaving = true
      this.$cf_api.closeFundingCampaign(this.fundingCampaign.fundingCampaignId).then(()=>{
        this.$store.dispatch('setSnack', 'Se ha cerrado la campaña de fondeo correctamente.')
        this.$emit('newCampaign')
      }).catch(e=>{
        console.log('Error submitting new funding campaign: ',e)
        this.$store.dispatch('setSnack', 'Ha habido un error. Intentar nuevamente mas tarde.')
      }).finally(()=>{
        this.isSaving = false
      })
    }
  }

}
</script>